export class CbcNoHeaderReceiver {
  private iv: Uint8Array | null = null;
  private buf = new Uint8Array(0);

  push(chunk: Uint8Array): { iv?: Uint8Array; ctBlocks?: Uint8Array } {
    if (!this.iv) {
      if (chunk.length !== 16)
        throw new Error(`Expected 16B IV, got ${chunk.length}`);
      this.iv = chunk.slice();

      return { iv: this.iv };
    }

    // Append ciphertext blocks
    const tmp = new Uint8Array(this.buf.length + chunk.length);
    tmp.set(this.buf);
    tmp.set(chunk, this.buf.length);
    this.buf = tmp;

    if (this.buf.length >= 32 && this.buf.length % 16 === 0) {
      const ct = this.buf;
      const iv = this.iv!;

      // ✅ Reset state after returning complete message
      this.buf = new Uint8Array(0);
      this.iv = null;

      return { iv, ctBlocks: ct };
    }

    return {};
  }

  reset() {
    //  console.log('🔄 Receiver reset');
    this.iv = null;
    this.buf = new Uint8Array(0);
  }

  // ✅ Add state inspection for debugging
  getState() {
    return {
      hasIV: !!this.iv,
      bufferLength: this.buf.length,
    };
  }
}
